import { errorPlayerContainerNotCreated } from './errors';
export const playerSetStaticProgramInfoCallback = (container, action) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const { programId, startTime, duration, } = action;
    if (!programId || !startTime || !duration) {
        throw new Error('programId, startTime, and duration are required');
    }
    const player = container.getPlayerZapi();
    player.setProgramInfoCallback(() => {
        return Promise.resolve({
            programId: Number(programId),
            start: Number(startTime),
            duration: Number(duration),
        });
    });
};
